<template>
    <div v-if="visible">
        <div class="backdrop"></div>
        <div class="dialog">
            <div class="dialog__header">
                <h1>Hdbt event</h1>
                <button class="close" @click="closeDialog">
                    <inline-svg class="logo" :src="require('@/assets/x-close.svg')" ></inline-svg>
                </button>
            </div>
            <div class="dialog__body">
                <div class="form" :class="{'loading': saving}">
                    <div class="form__item">
                        <label>Event name</label>
                        <input type="text" placeholder="Event name" v-model="v$.name.$model" />
                        <ErrorFormItemView :errors="v$.name.$errors"></ErrorFormItemView>
                    </div>
                    <div class="form__row">
                        <div class="form__item">
                            <label>Event logo</label>
                            <ImageFormView :imageUrl="logoUrl" @change="imageFormChangeHandler(v$.logoBase64, v$.logoFilename, $event)"></ImageFormView>
                            <ErrorFormItemView :errors="v$.logoBase64.$errors"></ErrorFormItemView>
                        </div>
                        <div class="form__item">
                            <label>Prizes</label>
                            <ImageFormView :imageUrl="prizesUrl" @change="imageFormChangeHandler(v$.prizesBase64, v$.prizesFilename, $event)"></ImageFormView>
                            <ErrorFormItemView :errors="v$.prizesBase64.$errors"></ErrorFormItemView>
                        </div>
                    </div>
                </div>
            </div>  
            <div class="dialog__footer">
                <button @click="closeDialog(null)" class="cancel">
                    <span>Cancel</span>
                </button>
                <button @click="submitHandler" :class="{'loading': saving}">
                    <span class="icon"></span>
                    <span>Save event</span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import firebaseService from "../../../services/firebase.service";
import { required } from '@vuelidate/validators';
import ImageFormView from '../shared/ImageFormView.vue';
import ErrorFormItemView from '../shared/ErrorFormItemView.vue';

export default {
    name: 'HdbtEventFormView',
    props: {
        visible: null,
        hdbtEvent: null
    },
    components: {
        ImageFormView,
        ErrorFormItemView
    },
    setup() {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            name: '',
            logoFilename: '',
            logoBase64: '',
            prizesFilename: '',
            prizesBase64: '',
            logoUrl: '',
            prizesUrl: '',
            saving: false
        }
    },
    validations() {
        const localRules = {
            name: { required },
            logoFilename: {},
            logoBase64: {},
            prizesFilename: {},
            prizesBase64: {}
        }

        if (null == this.logoUrl) {
            localRules.logoBase64 = { required };
        }
        if (null == this.prizesUrl) {
            localRules.prizesBase64 = { required };
        }
        return localRules;
    },
    watch: {
        visible: function(value) {
            if (value && this.hdbtEvent) {
                this.name = this.hdbtEvent.name;
                this.logoUrl = this.hdbtEvent.logoUrl;
                this.prizesUrl = this.hdbtEvent.prizesUrl;
            } else {
                this.name = null;
                this.logoUrl = null;
                this.prizesUrl = null;
            }
        },
        hdbtEvent: function (value) {
            if (value) {
                this.name = value.name;
                this.logoUrl = value.logoUrl;
                this.prizesUrl = value.prizesUrl;
            }
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close', null);
            this.v$.$reset();
        },
        async submitHandler() {
            try {
                const isFormCorrent = await this.v$.$validate();
                if (!isFormCorrent) {
                    return;
                }
                this.saving = true;
                const response = await firebaseService.saveEvent(
                    this.name,
                    { fileName: this.logoFilename, base64: this.logoBase64},
                    { fileName: this.prizesFilename, base64: this.prizesBase64}
                );
                if (response.logoUrl) {
                   response.logoUrl += `?${(new Date()).getTime()}`;
                }
                if (response.prizesUrl) {
                   response.prizesUrl += `?${(new Date()).getTime()}`;
                }
                this.saving = false;
                this.$emit('close', response);
            } catch (error) {
                console.error(error);
                this.saving = false;
            }
        },
        imageFormChangeHandler(base64, fileName, eventObject) {
            if (null == eventObject) {
                fileName.$model = null;
                base64.$model = null;
            } else {
                fileName.$model = eventObject.fileName;
                base64.$model = eventObject.base64;
            }
        }
    }
}

</script>
<style scoped lang="scss">
@import '../../../../public/css/admin.scss';
</style>